<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.state" size="small" style="width: 140px;margin-right: 10px"
                               placeholder="订单状态">
                        <el-option key="0" label="全部设备" value="0"></el-option>
                        <el-option key="1" label="未分配设备" value="1"></el-option>
                    </el-select>
                    <el-input size="small" placeholder="请输入设备id搜索" v-model="query.inquiryUid"
                              style="width: 240px" suffix-icon="el-icon-search">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" @click="addAgent" style="width: 96px">新增设备</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="id" label="id"></el-table-column>
                    <el-table-column prop="inquiryUid" label="设备编号"></el-table-column>
                    <el-table-column prop="hospitalName" label="诊所名"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="hospitalQuery(scope.row)">分配诊所</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增设备" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false">
            <el-form :model="agentAdd" :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item label="设备id:" prop="inquiryUid">
                    <el-input v-model="agentAdd.inquiryUid" style="width: 320px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="配置设备" :visible.sync="dialogEdVisible" width="560px"
                   :close-on-click-modal="false">
            <el-form :model="agentEd"   :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item prop="district" label-width="0">
                    <el-select v-model="agentEd.hospitalNo" placeholder="选择诊所"
                               style="width: 135px;">
                        <el-option v-for="item in hospital" :key="item.hospitalNo"
                                   :label="item.hospitalName" :value="item.hospitalNo"></el-option>
                    </el-select>
                    <span>设备id: {{ agentEd.inquiryId}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization: localStorage.getItem('authorization'),
                query: {
                    state: '0'
                },
                loading: true,
                tableData: [],
                hospital: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                dialogAddVisible: false,
                dialogEdVisible: false,
                agentAdd: {
                    inquiryUid: '',
                },
                agentEd: {
                    hospitalNo: ''
                },
                rules: {
                    inquiryUid: [{required: true, message: '请输入设备id', trigger: 'blur'}],

                },
            };
        },
        methods: {
            // 机器列表
            getData() {
                this.loading = true
                let params = new FormData()
                params.append('inquiryUid', this.query.inquiryUid)
                params.append('state', this.query.state)
                this.axios.post('/api-s/10045/100174/' + this.pageNum + "/" + this.pageSize, params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
            },
            cancelEd() {
                this.dialogEdVisible = false;
            },
            // 新增弹窗按钮
            addAgent() {
                this.dialogAddVisible = true
            },
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        this.axios.post('/api-s/10045/100173', this.agentAdd, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            confirmEd() {
                this.axios.post('/api-s/10045/100177', this.agentEd, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEdVisible = false
                        this.agentEd=  {
                            hospitalNo: ''
                        }
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            hospitalQuery(data) {
                console.log(data)
                if(data.hospitalName==null){
                    this.dialogEdVisible = true;

                    this.agentEd.inquiryId = data.inquiryUid
                this.axios.get('/api-s/10045/100178', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.hospital = res.data.data;

                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                }else {
                    this.$message.info("已在使用")
                }
            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            }

        },
        watch: {
            // 监听搜索框值变化,请求列表数据
            query: {
                handler() {
                    setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            },
            hospitalName: {
                handler() {
                    this.pageNum = 1
                    this.getData()
                }
            }
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .delete-button {
        margin-left: 20px;
        color: rgba(255, 75, 75, 1) !important;
    }

    .delete-button:hover {
        color: rgba(255, 75, 75, 0.8) !important;
    }

    .delete-button:focus {
        color: rgba(215, 37, 41, 1) !important;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
</style>